/**
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna pro stavový automat životního cyklu.
 */
class ViewerLifeCycleFactory {
  /**
   * Vytvoří instanci
   * @param {Class.<ViewerLifeCycle>} ViewerLifeCycle
   * @param {StateMachineFactory} stateMachineFactory
   * @returns {ViewerLifeCycleFactory} Nová instance.
   */
  constructor(ViewerLifeCycle, stateMachineFactory) {
    this.ViewerLifeCycle = ViewerLifeCycle;
    this.stateMachineFactory = stateMachineFactory;
  }

  /**
   * Vytvoří nový stavový automat životního cyklu.
   * @returns {ViewerLifeCycle} Vytvořený stavový automat.
   */
  create() {
    return new this.ViewerLifeCycle(this.stateMachineFactory);
  }
}

export default ViewerLifeCycleFactory;
